import { BreakpointObserver, MediaMatcher } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild, ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { CoreService } from 'src/app/services/core.service';
import { AppSettings } from 'src/app/config';
import { filter } from 'rxjs/operators';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';
import { navItems } from './vertical/sidebar/sidebar-data';
import { NavService } from '../../services/nav.service';
import { AppNavItemComponent } from './vertical/sidebar/nav-item/nav-item.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './vertical/sidebar/sidebar.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TablerIconsModule } from 'angular-tabler-icons';
import { HeaderComponent } from './vertical/header/header.component';
import { AppHorizontalHeaderComponent } from './horizontal/header/header.component';
import { AppHorizontalSidebarComponent } from './horizontal/sidebar/sidebar.component';
import { AppBreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { CustomizerComponent } from './shared/customizer/customizer.component';
import { BrandingComponent } from './vertical/sidebar/branding.component';
import { AuthenticationService } from 'src/app/services/apps/Authentication/authentication.service';
import { logoutToLogin } from 'src/app/services/apps/Authentication/logout-to-login';
import { CashBoxStatusService } from 'src/app/services/cash-box-status.service';
import { ToastrService } from 'ngx-toastr';
import { isCashBoxWarningRoute } from './cash-box-warning-route';
import { ModeService } from 'src/app/services/mode.service';
import { CabinTabBarComponent } from './shared/cabin-tab-bar/cabin-tab-bar.component';
import { AttentionSidebarComponent } from '../attention/sidebar/attention-sidebar.component';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';
const BELOWMONITOR = 'screen and (max-width: 1023px)';

@Component({
  selector: 'app-full',
  imports: [
    RouterModule,
    AppNavItemComponent,
    MaterialModule,
    CommonModule,
    SidebarComponent,
    NgScrollbarModule,
    TablerIconsModule,
    HeaderComponent,
    AppHorizontalHeaderComponent,
    AppHorizontalSidebarComponent,
    AppBreadcrumbComponent,
    CustomizerComponent,
    BrandingComponent,
    CabinTabBarComponent,
    AttentionSidebarComponent,
  ],
  templateUrl: './full.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .vp-dashboard-route-host {
        position: relative;
        min-height: 50vh;
      }
      .vp-dashboard-route-boot {
        position: absolute;
        inset: 0;
        z-index: 2;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        min-height: min(50vh, 480px);
        background: color-mix(
          in srgb,
          var(--mat-sidenav-content-background-color, #fafafa) 93%,
          transparent
        );
      }
      .mainWrapper.attention-shell .attention-sidenav.mat-drawer,
      .mainWrapper.attention-shell .attention-sidenav.mat-sidenav {
        width: min(260px, 88vw);
        min-width: 220px;
      }
      .attention-sidenav-inner {
        height: 100%;
        min-height: 0;
      }
    `,
  ],
})
export class FullComponent implements OnInit, AfterViewInit, OnDestroy {
  navItems = navItems;  @ViewChild('leftsidenav', { static: false })
  public sidenav: MatSidenav;
  
  @ViewChild('mobilesidenav')
  public mobileSidenav: MatSidenav;
  resView = false;
  @ViewChild('content', { static: true }) content!: MatSidenavContent;
  //get options from service
  options = this.settings.getOptions();
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  private htmlElement!: HTMLHtmlElement;
  private currentUserSubscription?: Subscription;

  userName: string = '';
  userRole: string = 'Guest';
  /** Estado API: sin caja abierta. */
  private tenantHasNoOpenCashBox = false;
  /**
   * Evita spam de toasts: una notificación por “período sin caja” mientras el API sigue
   * reportando sin cajas activas; se resetea cuando hay al menos una caja abierta.
   */
  private noCashBoxToastShownForCurrentApiState = false;
  /** Toast visible de este aviso; se cierra al salir de cobro/salida o al abrir una caja. */
  private cashBoxToastId: number | null = null;
  private cashBoxStatusSubscription = Subscription.EMPTY;
  private routerEventsSubscription = Subscription.EMPTY;
  /** Lazy load de `dashboards` + primer paint: el componente aún no existe; feedback en el layout. */
  dashboardRouteLoading = false;
  private dashboardNavSubscription = Subscription.EMPTY;

  /** Modo Cabina (#191): sin sidebar; tab-bar bajo el header. */
  cabinShell = false;
  /** Modo Atención (#192): sidebar corto fijo + buscador global en header. */
  attentionShell = false;
  private modeSubscription = Subscription.EMPTY;

  get isOver(): boolean {
    return this.isMobileScreen;
  }

  get isTablet(): boolean {
    return this.resView;
  }

  constructor(
    private settings: CoreService,
    private mediaMatcher: MediaMatcher,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private navService: NavService,
    private authenticationService: AuthenticationService,
    private cashBoxStatusService: CashBoxStatusService,
    private toastr: ToastrService,
    private modeService: ModeService
  ) {
    this.htmlElement = document.querySelector('html')!;
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW, BELOWMONITOR])
      .subscribe((state) => {
        // SidenavOpened must be reset true when layout changes
        this.options.sidenavOpened = true;
        this.isMobileScreen = state.breakpoints[BELOWMONITOR];
        // El sidebar arranca expandido (no auto-colapsar en vista tablet);
        // el usuario lo colapsa manualmente con el toggle del header.
        this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
        this.resView = state.breakpoints[BELOWMONITOR];
      });

    // Initialize project theme with options
    this.receiveOptions(this.options);

    // Scroll al cambiar de ruta; el aviso de caja solo aplica en cobro/salida.
    this.routerEventsSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.content.scrollTo({ top: 0 });
        this.syncCashBoxNotification();
      });

    this.dashboardNavSubscription = this.router.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        const path = (e.url ?? '').split('?')[0];
        if (path.startsWith('/dashboards') || path.startsWith('dashboards/')) {
          this.dashboardRouteLoading = true;
        }
      } else if (e instanceof NavigationEnd || e instanceof NavigationCancel) {
        this.dashboardRouteLoading = false;
      }
    });

    this.applyUserInfo(this.authenticationService.getCurrentUserSnapshot());
    this.currentUserSubscription = this.authenticationService.currentUser$.subscribe(
      (user) => this.applyUserInfo(user)
    );
  }

  ngOnInit(): void {
    this.applyUserInfo(this.authenticationService.getCurrentUserSnapshot());
    this.cashBoxStatusSubscription = interval(60_000)
      .pipe(startWith(0))
      .subscribe(() => this.refreshCashBoxBanner());

    this.modeService.hydrateFromStorage();
    this.updateShellLayout();
    this.modeSubscription = this.modeService.getActiveMode$().subscribe(() => this.updateShellLayout());
  }

  ngAfterViewInit(): void {
    // Implement the required method for AfterViewInit interface
    // You can put your after view initialization logic here
  }

  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
    this.routerEventsSubscription.unsubscribe();
    this.cashBoxStatusSubscription.unsubscribe();
    this.dashboardNavSubscription.unsubscribe();
    this.modeSubscription.unsubscribe();
    if (this.currentUserSubscription) {
      this.currentUserSubscription.unsubscribe();
    }
  }

  private updateShellLayout(): void {
    const mode = this.modeService.getActiveModeSnapshot();
    const key = mode?.key;
    this.cabinShell = !this.options.horizontal && key === 'cabin';
    this.attentionShell = !this.options.horizontal && key === 'attention';
  }

  private refreshCashBoxBanner(): void {
    this.cashBoxStatusService.getTenantStatus().subscribe({
      next: (status) => {
        this.tenantHasNoOpenCashBox = !status.hasActiveCashBoxes;
        if (!this.tenantHasNoOpenCashBox) {
          this.noCashBoxToastShownForCurrentApiState = false;
        }
        this.syncCashBoxNotification();
      },
      error: () => {
        this.tenantHasNoOpenCashBox = false;
        this.noCashBoxToastShownForCurrentApiState = false;
        this.syncCashBoxNotification();
      },
    });
  }

  /**
   * Una vez por período sin caja, y solo en cobro/salida.
   * El dedupe se rearma cuando el API reporta una caja abierta, no al pasar por un tablero.
   */
  private syncCashBoxNotification(): void {
    const showOnThisRoute =
      this.tenantHasNoOpenCashBox && isCashBoxWarningRoute(this.router.url);
    if (!showOnThisRoute) {
      this.dismissCashBoxToast();
      return;
    }
    if (this.noCashBoxToastShownForCurrentApiState) {
      return;
    }
    this.noCashBoxToastShownForCurrentApiState = true;
    const toast = this.toastr.warning(
      'Los cobros quedan bloqueados y la salida automática no puede completarse hasta que un operador abra una caja.',
      'Sin caja abierta en el estacionamiento',
      {
        timeOut: 14_000,
        closeButton: true,
        tapToDismiss: true,
        positionClass: 'toast-top-right',
      }
    );
    this.cashBoxToastId = toast?.toastId ?? null;
  }

  private dismissCashBoxToast(): void {
    if (this.cashBoxToastId == null) {
      return;
    }
    this.toastr.clear(this.cashBoxToastId);
    this.cashBoxToastId = null;
  }

  /** Mismo cierre que avatar > Usuario > Cerrar sesión. */
  onLogout(): void {
    logoutToLogin(this.authenticationService, this.router);
  }

  toggleCollapsed() {
    if (this.cabinShell) {
      return;
    }
    this.isContentWidthFixed = false;
    this.options.sidenavCollapsed = !this.options.sidenavCollapsed;
    this.resetCollapsedState();
  }

  /** Alterna sidebar móvil/desktop; no-op en modo Cabina (sin sidebar). */
  toggleSideNav(): void {
    if (this.cabinShell) {
      return;
    }
    if (this.resView && this.mobileSidenav) {
      this.mobileSidenav.toggle();
    } else if (this.sidenav) {
      this.sidenav.toggle();
    }
  }

  resetCollapsedState(timer = 400) {
    setTimeout(() => this.settings.setOptions(this.options), timer);
  }
  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
    this.options.sidenavOpened = false;
    this.settings.setOptions(this.options);
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
    this.options.sidenavOpened = isOpened;
    this.settings.setOptions(this.options);
  }

  // Helper method to toggle the appropriate sidenav
  toggleSidenav() {
    if (this.resView && this.mobileSidenav) {
      this.mobileSidenav.toggle();
    } else if (this.sidenav) {
      this.sidenav.toggle();
    }
  }

  receiveOptions(options: AppSettings): void {
    //this.options = options;

    this.toggleDarkTheme(options);
    this.toggleColorsTheme(options);
    this.updateShellLayout();
  }

  toggleDarkTheme(options: AppSettings) {
    if (options.theme === 'dark') {
      this.htmlElement.classList.add('dark-theme');
      this.htmlElement.classList.remove('light-theme');
    } else {
      this.htmlElement.classList.remove('dark-theme');
      this.htmlElement.classList.add('light-theme');
    }
  }

  toggleColorsTheme(options: AppSettings) {
    // Remove any existing theme class dynamically
    this.htmlElement.classList.forEach((className) => {
      if (className.endsWith('_theme')) {
        this.htmlElement.classList.remove(className);
      }
    });

    // Add the selected theme class
    this.htmlElement.classList.add(options.activeTheme);
  }

  private applyUserInfo(user: any | null): void {
    this.userName = this.authenticationService.getDisplayName(user);
    this.userRole = this.authenticationService.getDisplayRole(user) || 'Guest';
  }
}
